import { LayoutContainer } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomMainNavBar from "../../../components/CustomHeader/CustomMainNavBar";
import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfiguracionStandVirtualScreen from "../configuracion/screens/ConfiguracionStandVirtualScreen";
import ProcedimientosStandVirtualScreen from "../configuracion/screens/ProcedimientosStandVirtualScreen";
import standVirtualRoutes from "../standVirtualRoutes";
import { MainContent } from "../styles/MainLayoutStandVirtualStyles";
import StandVirtualDashboardScreen from "../dashboard/screens/StandVirtualDashboardScreen";
import AdministracionUsuariosScreen from "../usuarios/screens/AdministracionUsuariosScreen";
import StandVirtualReportesScreen from "../reportes/screens/StandVirtualReportesScreen";
import PrecertificacionVerScreen from "../certificacion/screens/PrecertificacionVerScreen";
import PrecertificacionModificarScreen from "../certificacion/screens/PrecertificacionModificarScreen";
import PrecertificacionesConsultarScreen from "../certificacion/screens/PrecertificacionesConsultarScreen";
import PrivateStandVirtualRoute from "./PrivateStandVirtualRoute";
import { routes } from "../../../routes/app-routes";

const MainLayoutStandVirtual = () => {
  const authUserData = useSelector((state) => state.auth.authUserData);
  const { prestador, isEmailUser } = authUserData || {};
  const userRoles = prestador?.roles || [];

  // Check if email user has no roles configured
  const hasEmailSymbol = (typeof prestador?.codigo === 'string' && prestador?.codigo?.includes("@")) || prestador?.email?.includes("@") || isEmailUser;
  
  if (hasEmailSymbol && userRoles.length === 0) {
    return <Redirect to={routes.unauthorized} />;
  }

  return (
    <LayoutContainer>
      <CustomMainNavBar />
      <MainContent>
        <Switch>
          <Route
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionModificar.route}`}
            component={PrecertificacionModificarScreen}
          />

          <Route
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionVer.route}`}
            component={PrecertificacionVerScreen}
          />

          <Route
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacion.route}`}
            component={PrecertificacionesConsultarScreen}
          />

          <Route
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.main.route}`}
            component={StandVirtualDashboardScreen}
          />

          <PrivateStandVirtualRoute
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.configuracion.route}`}
            component={ConfiguracionStandVirtualScreen}
            requiredPermissions={
              standVirtualRoutes.dashboard.configuracion.requiredPermissions
            }
          />

          <PrivateStandVirtualRoute
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.procedimientos.route}`}
            component={ProcedimientosStandVirtualScreen}
            requiredPermissions={
              standVirtualRoutes.dashboard.documentos.requiredPermissions
            }
          />

          <PrivateStandVirtualRoute
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.users.route}`}
            component={AdministracionUsuariosScreen}
            requiredPermissions={
              standVirtualRoutes.dashboard.users.requiredPermissions
            }
          />

          <PrivateStandVirtualRoute
            exact
            path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.reporteria.route}`}
            component={StandVirtualReportesScreen}
            requiredPermissions={
              standVirtualRoutes.dashboard.reporteria.requiredPermissions
            }
          />

          <Route path="*">
            <Redirect
              to={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.main.route}`}
            />
          </Route>
        </Switch>
      </MainContent>
    </LayoutContainer>
  );
};

export default MainLayoutStandVirtual;
